import { useQuery } from '@tanstack/react-query';
import { getHeaders, isAccessTokenAvailable } from '../../../utils/commonMethods';
import { request } from '../../../utils/axios';

export function useInitialLoadForDeepLinks({ loadPropertyList = false } = {}) {
  // Without a token these requests would 401 and the axios interceptor would restart the OAuth flow
  // without the `state` return path, overriding the redirect started by AppLoader.
  const isAuthenticated = isAccessTokenAvailable();

  const { data: defaultWorkspace, isFetched: isWorkspaceFetched } = useQuery({
    queryKey: ['workspaces'],
    queryFn: async () => {
      return request
        .get<{ content: { id: string }[] }>('v2/workspaces?size=1', {
          headers: getHeaders().common
        })
        .then((res) => res.data.content?.[0]);
    },
    enabled: isAuthenticated
  });

  const { data: defaultOrg, isFetched: isOrgFetched } = useQuery({
    queryKey: ['orgs'],
    queryFn: async () => {
      return request
        .get<{ content: { id: string; workspace_id: string }[] }>('v2/orgs?size=1', {
          headers: getHeaders().common
        })
        .then((res) => res.data.content?.[0]);
    },
    enabled: isAuthenticated
  });

  const { data: defaultProperty, isFetched: isPropertyFetched } = useQuery({
    queryKey: [`orgs/${defaultOrg?.id}/properties`],
    queryFn: async () => {
      return request
        .get<{ content: { id: string; org_id: string }[] }>(
          `v2/orgs/${defaultOrg?.id}/properties?size=1`,
          {
            headers: getHeaders().common
          }
        )
        .then((res) => res.data.content?.[0]);
    },
    enabled: isAuthenticated && !!defaultOrg?.id && loadPropertyList
  });

  return {
    isWorkspaceFetched,
    isOrgFetched,
    isPropertyFetched,
    defaultWorkspace,
    defaultOrg,
    defaultProperty
  };
}
